export const ssq = {
	active: 0,
	arr: [
		{
			value: 1, label: '分析型条件红表', cont_active: '',
			cont: ["红球6-9码=0-1", "红球10-17码=0-2", "红球2-4码=1-2", "红球5-6码=1-3", "红球7-9码=2-4", "红球10-12码=3-4", "红球13-15码=4-6"]
		},
		{
			value: 2, label: '分析型条件蓝表', cont_active: '',
			cont: ["篮球2-6码=0-0", "篮球3-8码=1-1"]
		},
		{
			value: 3, label: '排序型条件红表', cont_active: '',
			cont: ["红球6-9码=0-1", "红球10-17码=0-2", "红球2-4码=1-2", "红球5-6码=1-3", "红球7-9码=2-4", "红球10-12码=3-4", "红球13-15码=4-6"]
		},
		{
			value: 4, label: '排序型条件蓝表', cont_active: '',
			cont: ["篮球2-6码=0-0", "篮球3-8码=1-1"]
		},
	],
}
export const dlt = {
	active: 0,
	arr: [
		{
			value: 5, label: '分析型前区表', cont_active: '',
			cont: ["大乐透前区6-11码=0-1", "大乐透前区12-20码=0-2", "大乐透前区34码=1-2", "大乐透前区5-7码=1-3", "大乐透前区8-10码=2-4", "大乐透前区11-13码=3-4", "大乐透前区14-16码=3-5"]
		},
		{
			value: 6, label: '分析型后区表', cont_active: '',
			cont: ["大乐透后区24码=0-0", "大乐透后区4-10码=0-1", "大乐透后区3-6码=1-2"]
		},
		{
			value: 7, label: '排序型前区表', cont_active: '',
			cont: ["大乐透前区6-11码=0-1", "大乐透前区12-20码=0-2", "大乐透前区34码=1-2", "大乐透前区5-7码=1-3", "大乐透前区8-10码=2-4", "大乐透前区11-13码=3-4", "大乐透前区14-16码=3-5"]
		},
		{
			value: 8, label: '排序型后区表', cont_active: '',
			cont: ["大乐透后区24码=0-0", "大乐透后区4-10码=0-1", "大乐透后区3-6码=1-2"]
		},
	]
}
export const fcsd = {
	active: 0,
	arr: [
		{
			value: 9, label: '分析型3D表', cont_active: '',
			cont: ["3D杀3-6码=0-1", "3D杀2-3码=0-0", "3D胆2-3码=1-2", "3D胆35码=1-3", "4码定个位", "4码定十位", "4码定百位"]
		},
		{
			value: 10, label: '排序型3D表', cont_active: '',
			cont: ["3D杀3-6码=0-1", "3D杀2-3码=0-0", "3D胆2-3码=1-2", "3D胆35码=1-3"]
		},
	]
}
export const pls = {
	active: 0,
	arr: [
		{
			value: 11, label: '分析型排三表', cont_active: '',
			cont: ["3D杀3-6码=0-1", "3D杀2-3码=0-0", "3D胆2-3码=1-2", "3D胆35码=1-3", "4码定个位", "4码定十位", "4码定百位"]
		},
		{
			value: 12, label: '排序型排三表', cont_active: '',
			cont: ["3D杀3-6码=0-1", "3D杀2-3码=0-0", "3D胆2-3码=1-2", "3D胆35码=1-3"]
		},
	]
}
